export type CreateAccountEmailVerificationSlice = {
    sendOtp: {
        error: Error;
        submitted: boolean;
        success: boolean;
    };
    /** This is a temporary user id that is used to identify the user in the backend before the user is created */
    unregisteredUserId: number | null;
    verifyOtp: {
        error: Error;
        submitted: boolean;
        success: boolean;
    };
};

export const defaultCreateAccountEmailVerificationSlice: CreateAccountEmailVerificationSlice = {
    sendOtp: {
        error: null,
        submitted: false,
        success: false,
    },
    unregisteredUserId: null,
    verifyOtp: {
        error: null,
        submitted: false,
        success: false,
    },
};

export type SendEmailVerificationCodePayload = {
    email: string;
};
export type SubmitEmailVerificationCodePayload = {
    onSuccess: () => void;
    otp: string;
};
